module.exports = __webpack_public_path__ + "static/media/travels-with-my-aunt-graham-greene.dabd1f0a.jpg";